import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentShareableUserInfo on ShareableUserInfo {
    id
    name
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentShareableUserInfoFragment,
  ents.core.admin.User.ShareableInfo
>({
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  name: graphql.transformers.OUT.default(
    transformers.PASS_THROUGH,
    'Unknown User',
  ),
})
